module.exports = __webpack_public_path__ + "img/pallets_business.54147ba1.png";